/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

import React from "react";
import { Link } from "react-router-dom";
import { IconButton, Link as MuiLink, Typography } from "@mui/material";
import { XIcon } from "../../FontAwesome";
import { translationKeys, useTranslation } from "../../Internationalisierung/i18nBasis";
import { useViewHistory } from "../ViewHistoryContext";
import ViewMenu from "../ViewMenu";
import ViewMenuItem from "../ViewMenu/ViewMenuItem";
import "./ViewHeader.scss";

export interface ViewHeaderProps {
    title: React.ReactNode;
    processCaption?: string;
    viewMenuItems?: Array<ViewMenuItem>;
    hideCloseButton?: boolean;
    onClose?: () => void;
    to?: string;
}

export default function ViewHeader(props: ViewHeaderProps) {
    const { t } = useTranslation();
    const viewHistory = useViewHistory();
    return (
        <div className="lan-viewheader">
            {props.viewMenuItems && <ViewMenu items={props.viewMenuItems} />}

            <div className="lan-viewheader__titlecontainer">
                <Typography
                    noWrap
                    variant="h2"
                    sx={{
                        marginLeft: "0.5rem",
                        fontSize: "0.75rem",
                        color: "text.secondary",
                    }}
                >
                    {props.processCaption}
                </Typography>
                <Typography
                    noWrap
                    variant="h3"
                    className="lan-viewheader__title lan-viewheader__title-clarity"
                >
                    {props.to ? (
                        <MuiLink component={Link} color="inherit" to={props.to} underline="hover">
                            {props.title}
                        </MuiLink>
                    ) : (
                        props.title
                    )}
                </Typography>
            </div>
            {!props.hideCloseButton && (
                <IconButton
                    className="lan-viewarrowback"
                    onClick={props.onClose ? props.onClose : viewHistory.closeCurrentView}
                    size="large"
                    title={t(translationKeys.viewHeader.zurueckTitel)}>
                    <XIcon />
                </IconButton>
            )}
        </div>
    );
}
